import { AgentAvatar } from "@circle-react/components/Modals/MessagingModal/LeftSidebar/List/BotChatList/AgentAvatar";
import { useCommunityInboxStore } from "@circle-react/hooks/chatsV2/store";
import { TiptapEditor } from "@circle-react-shared/uikit/TipTap";
import { Typography } from "@circle-react-uikit/Typography";
import { SuggestedQuestionButton } from "../Shared/SuggestedQuestionButton";

interface PreviewConversationBlockProps {
  createMessage: (data: { body: object; pause_ai_minutes?: number }) => void;
}

export const PreviewConversationBlock = ({
  createMessage,
}: PreviewConversationBlockProps) => {
  const { currentBotProfile } = useCommunityInboxStore();

  if (!currentBotProfile) {
    return null;
  }
  const { name, bio } = currentBotProfile;

  const formatMessageBody = (text: string) => ({
    type: "doc",
    content: [
      {
        type: "paragraph",
        content: [
          {
            type: "text",
            text: text,
          },
        ],
      },
    ],
  });

  return (
    <div className="mx-2 mb-4">
      <div className="mb-4">
        <AgentAvatar profile={currentBotProfile} />
      </div>
      <Typography.LabelMd as="div" weight="semibold">
        {name}
      </Typography.LabelMd>
      {bio && (
        <div className="text-default mt-1 whitespace-pre-line text-sm font-normal">
          <TiptapEditor editable={false} rich_text_body={bio} />
        </div>
      )}

      {currentBotProfile?.suggested_questions &&
        currentBotProfile.suggested_questions.length > 0 && (
          <div className="mt-4 flex flex-wrap items-center gap-2">
            {currentBotProfile.suggested_questions.map((question: string) => (
              <SuggestedQuestionButton
                key={question}
                question={question}
                onClick={() =>
                  createMessage({
                    body: {
                      body: formatMessageBody(question),
                      attachments: [],
                      localAttachments: [],
                      localSgidToObjectMap: {},
                    },
                  })
                }
              />
            ))}
          </div>
        )}
    </div>
  );
};
